import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1425.128 -4149)">
      <path
        d="M215.622.75a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4149)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M230.381,13.148A14.986,14.986,0,0,0,215.622.751v15l-12.98,7.494a14.974,14.974,0,0,0,27.739-10.1"
        transform="translate(-1625 4149)"
        fill={color}
      />
    </g>
  </svg>
);
